import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";
// creates a beautiful scrollbar
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import Notifications from "@material-ui/icons/Notifications";
// core components/views for Admin layout
import UserProfile from "../views/UserProfile/UserProfile.js";
import Menus from "../views/CategoryTable/MenuTableList.js";
import UserTransactions from "../views/Users/UserTransactions.jsx";
import CategoryEdit from "../views/CategoryTable/CategoryEdit.js";
import SubCategoryEdit from "../views/CategoryTable/SubCategoryEdit.js";
import SuperCategory from "../views/CategoryTable/SuperCategory.js";
import VendorDetail from "../views/Vendor/VendorDetail.js";
import AddCategory from "../views/CategoryTable/AddCategory.js";
import AddSubCategory from "../views/CategoryTable/AddSubCategory.js";
import CategoriesTable from "../views/CategoryTable/CategoriesTable.js";
import SubCategoriesTable from "../views/CategoryTable/SubCategoriesTable.js";
import Typography from "../views/Typography/Typography.js";
import Icons from "../views/Icons/Icons.js";
import Maps from "../views/Maps/Maps.js";
// core components
import Navbar from "../components/Navbars/Navbar.js";
import Footer from "../components/Footer/Footer.js";
import Sidebar from "../components/Sidebar/Sidebar.js";

import routes from "../routes.js";

import styles from "../assets/jss/material-dashboard-react/layouts/adminStyle.js";

import bgImage from "../assets/img/sidebar-2.jpg";
import logo from "../assets/img/logo.png";
import AddRestaurantType from "../views/RestaurantType/AddRestaurantType";
import AddDiscount from "../views/CategoryTable/AddDiscount.js";
import DriverDetail from "../views/DeliveryBoys/DriverDetail.js";
import AddSms from "../views/SMS/AddSms.jsx";
import ViewEvent from "../views/CategoryTable/ViewEvent.js";

let ps;

const switchRoutes = (
  <Switch>
    {routes.map((prop, key) => {
      if (prop.layout === "/admin") {
        return (
          <Route
            path={prop.layout + prop.path}
            component={prop.component}
            key={key}
          />
        );
      }
      return null;
    })}
  </Switch>
);

const useStyles = makeStyles(styles);

const Admin = ({ ...rest }) => {
  const classes = useStyles();
  const mainPanel = React.createRef();
  const image = bgImage;
  const color = "blue";
  // const [fixedClasses, setFixedClasses] = React.useState('dropdown show');
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const valueUserLoginType = localStorage.getItem("userLoginType") || "";
  // const handleColorClick = color => {
  //   setColor(color);
  // };
  // const handleFixedClick = () => {
  //   if (fixedClasses === 'dropdown') {
  //     setFixedClasses('dropdown show');
  //   } else {
  //     setFixedClasses('dropdown');
  //   }
  // };
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };
  const getRoute = () => {
    return window.location.pathname !== "/admin/maps";
  };
  const resizeFunction = () => {
    if (window.innerWidth >= 960) {
      setMobileOpen(false);
    }
  };
  // initialize and destroy the PerfectScrollbar plugin
  React.useEffect(() => {
    if (navigator.platform.indexOf("Win") > -1) {
      ps = new PerfectScrollbar(mainPanel.current, {
        suppressScrollX: true,
        suppressScrollY: false,
      });
      document.body.style.overflow = "hidden";
    }
    window.addEventListener("resize", resizeFunction);
    // Specify how to clean up after this effect:
    return function cleanup() {
      if (navigator.platform.indexOf("Win") > -1) {
        ps.destroy();
      }
      window.removeEventListener("resize", resizeFunction);
    };
  }, [mainPanel]);
  return (
    <div className={classes.wrapper}>
      {valueUserLoginType !== "admin" ? (window.location.href = "/") : ""}
      <Sidebar
        routes={routes}
        logoText={"Grospick Admin"}
        logo={logo}
        image={image}
        style={{ textDecoration: "none" }}
        handleDrawerToggle={handleDrawerToggle}
        open={mobileOpen}
        color={color}
        {...rest}
      />
      <div className={classes.mainPanel} ref={mainPanel}>
        <Navbar
          routes={routes}
          style={{ textDecoration: "none", backgroundColor: "#FFF" }}
          handleDrawerToggle={handleDrawerToggle}
          {...rest}
        />
        {/* On the /maps route we want the map to be on full screen - this is not possible if the content and conatiner classes are present because they have some paddings which would make the map smaller */}
        {getRoute() ? (
          <div
            className={classes.content}
            style={{ textDecoration: "none", backgroundColor: "#F6F0D6" }}
          >
            <div
              style={{ textDecoration: "none" }}
              className={classes.container}
            >
              {switchRoutes}
              <Switch>
                <Route
                  exact="true"
                  path="/admin/user"
                  component={UserProfile}
                />
                <Route
                  exact="true"
                  path="/admin/typography"
                  component={Typography}
                />
                <Route
                  exact="true"
                  path="/admin/all-category/:superCategoryId"
                  component={CategoriesTable}
                />
                <Route
                  exact="true"
                  path="/admin/view-event/:ip"
                  component={ViewEvent}
                />
                <Route
                  exact="true"
                  path="/admin/user/transactions/:id"
                  component={UserTransactions}
                />
                <Route
                  exact="true"
                  path="/admin/sub-category/:superCategoryId/:categoryId"
                  component={SubCategoriesTable}
                />
                <Route
                  exact="true"
                  path="/admin/super-category-edit/:superCategoryId"
                  component={SuperCategory}
                />
                <Route
                  exact="true"
                  path="/admin/menus/vendor/:vendorId"
                  component={Menus}
                />
                <Route
                  exact="true"
                  path="/admin/vendor-edit/:vendorId"
                  component={VendorDetail}
                />
                <Route
                  exact="true"
                  path="/admin/category-edit/:superCategoryId/:categoryId"
                  component={CategoryEdit}
                />
                <Route
                  exact="true"
                  path="/admin/sub-category-edit/:superCategoryId/:categoryId/:subCategoryId"
                  component={SubCategoryEdit}
                />
                <Route
                  exact="true"
                  path="/admin/add-super-category"
                  component={SuperCategory}
                />
                <Route
                  exact="true"
                  path="/admin/add-discount"
                  component={AddDiscount}
                />
                <Route
                  exact="true"
                  path="/admin/edit-discount/:id"
                  component={AddDiscount}
                />
                <Route
                  exact="true"
                  path="/admin/edit-driver/:id"
                  component={DriverDetail}
                />

                <Route
                  exact="true"
                  path="/admin/add-category/:superCategoryId"
                  component={AddCategory}
                />
                <Route
                  exact="true"
                  path="/admin/add-sub-category/:superCategoryId/:categoryId"
                  component={AddSubCategory}
                />
                <Route
                  exact="true"
                  path="/admin/vendor/details/:id"
                  component={Icons}
                />
                <Route
                  exact="true"
                  path="/admin/user/details/:id"
                  component={UserProfile}
                />
                <Route
                  exact="true"
                  path="/admin/add-restaurant-type"
                  component={AddRestaurantType}
                />
                <Route
                  exact="true"
                  path="/admin/restaurant-type-edit/:id"
                  component={AddRestaurantType}
                />
                <Route
                  exact="true"
                  path="/admin/allVendor"
                  component={UserProfile}
                />
                <Route
                  exact="true"
                  path="/admin/add-vendor"
                  component={VendorDetail}
                />
                <Route
                  exact="true"
                  path="/admin/add-driver"
                  component={DriverDetail}
                />
                <Route exact="true" path="/admin/add-sms" component={AddSms} />
                <Route exact="true" path="/admin/maps" component={Maps} />
                <Route
                  exact="true"
                  path="/admin/orders"
                  component={Notifications}
                />
                <Route
                  exact="true"
                  path="/admin/addRestaurant"
                  component={Notifications}
                />
                <Route
                  exact="true"
                  path="/admin/restaurants"
                  component={Notifications}
                />
                <Route
                  exact="true"
                  path="/admin/notifications"
                  component={Notifications}
                />
                <Redirect exact="true" from="/admin" to="/admin/dashboard" />
              </Switch>
            </div>
          </div>
        ) : (
          <div className={classes.map} style={{ textDecoration: "none" }}></div>
        )}
        {getRoute() ? null : null}
      </div>
    </div>
  );
};

export default Admin;
